import { createContext, type ReactNode, useContext } from 'react';
import type { AppRuntime } from './bootstrap';

/**
 * Exposes the app singletons (api client, session store, flag evaluator,
 * query client, config) to components that genuinely need them — primarily
 * the hotel switcher and logout. Feature code reads server state through query
 * hooks, not through this context.
 */
const RuntimeContext = createContext<AppRuntime | null>(null);

export function RuntimeProvider({
  runtime,
  children,
}: {
  runtime: AppRuntime;
  children: ReactNode;
}) {
  return <RuntimeContext.Provider value={runtime}>{children}</RuntimeContext.Provider>;
}

export function useRuntime(): AppRuntime {
  const ctx = useContext(RuntimeContext);
  if (!ctx) throw new Error('useRuntime must be used within <RuntimeProvider>');
  return ctx;
}
